export interface CreationData {
  code: string;
  email?: string;
  origin: CreationDataOrigin;
  businessOrigin?: string;
}

export enum CreationDataOriginEnum {
  AGENDA = 'AGENDA',
  B2B = 'B2B',
  B2C = 'B2C',
  API = 'API',
}
export type CreationDataOrigin = `${CreationDataOriginEnum}`;
